import React from 'react'
import about from '../images/about.jpg'
export const AboutUs = () => {
  return (
    <div className='about-container'>
        <div className='about-wrap'>
            <div className='about-1'>
                <div className='about-image'><img src={about} alt="" /></div>
            </div>
            <div className='about-2'>
                <div className='about-header'>About the Ekam Group</div>
                <div className='about-desc'>Ekam Group is a dynamic Ghanaian conglomerate with a strong presence across six diverse sectors: agriculture, oil and gas, real estate and construction, gold mining, education and training, and finance investment. Driven by a commitment to excellence, sustainability, and innovation, our portfolio of companies combines deep industry expertise with a mission to drive growth and deliver value across Africa</div>
            </div>
        </div>
    </div>
  )
}
